module.exports = __webpack_public_path__ + "static/media/maur-bg.95090226.jpg";